"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCorporateSchema = exports.createCorporateSchema = exports.corporateShape = exports.corporateTypeEnum = void 0;
const zod_1 = require("zod");
// Corporate Credit Management — Phase 1 (master data only). See
// schema.prisma's `Corporate` model doc comment for why this is its
// own master, auto-linked to (not a re-skin of) PayerMaster.
exports.corporateTypeEnum = zod_1.z.enum([
    'COMPANY',
    'GOVERNMENT',
    'PSU',
    'TRUST',
    'INSURANCE_LINKED',
    'SCHOOL',
    'COLLEGE',
    'INDUSTRY',
    'NGO',
    'OTHER',
]);
exports.corporateShape = {
    corporateCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    shortName: zod_1.z.string().max(100).nullable().optional(),
    type: exports.corporateTypeEnum,
    gstNumber: zod_1.z.string().max(20).nullable().optional(),
    panNumber: zod_1.z.string().max(20).nullable().optional(),
    registrationNumber: zod_1.z.string().max(50).nullable().optional(),
    addressLine1: zod_1.z.string().max(255).nullable().optional(),
    addressLine2: zod_1.z.string().max(255).nullable().optional(),
    city: zod_1.z.string().max(100).nullable().optional(),
    state: zod_1.z.string().max(100).nullable().optional(),
    country: zod_1.z.string().max(100).nullable().optional(),
    pin: zod_1.z.string().max(10).nullable().optional(),
    remarks: zod_1.z.string().nullable().optional(),
    isActive: zod_1.z.boolean().optional(),
};
exports.createCorporateSchema = zod_1.z.object(exports.corporateShape);
exports.updateCorporateSchema = exports.createCorporateSchema.partial();
//# sourceMappingURL=corporate.schema.js.map